<!--page-wrapper Start-->
<div class="page-wrapper">
  <router-outlet></router-outlet>
</div>
<!--page-wrapper Ends-->
